import { buildAction } from 'store/actions/actionCreator'

import { FETCH_COUNTRIES } from './constants'

export const fetchCountries = buildAction(FETCH_COUNTRIES, 'payload')
